export enum OrderStatus {
    Pending = 'pending',
    Placed = 'placed',
    InFulfillment = 'in_fulfillment',
    Completed = 'completed',
    Cancelled = 'cancelled',
}